"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var react_1 = __importDefault(require("react"));
var nouislider_1 = require("nouislider");
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.sliderRef = react_1.default.createRef();
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.sliderRef.current)
            return;
        var tooltipFunction = this.props.tooltipFunction || Math.trunc;
        this.slider = (0, nouislider_1.create)(this.sliderRef.current, {
            start: [this.props.startPosition, this.props.endPosition],
            behaviour: "drag",
            tooltips: [
                { from: Number, to: tooltipFunction },
                { from: Number, to: tooltipFunction },
            ],
            animate: false,
            connect: true,
            step: this.props.step,
            range: { min: this.props.rangeMin, max: this.props.rangeMax },
        });
        this.slider.on("slide", function (_values, _handle, unencoded) {
            if (_this.props.onChange) {
                _this.props.onChange(Math.round(unencoded[0]), Math.round(unencoded[1]));
            }
        });
    };
    Slider.prototype.render = function () {
        // If there's a change in start/end position generated by a prop change, we need to force it
        // TODO: could this be optimized to only perform an update when the value has actually changed?
        if (this.slider)
            this.slider.set([this.props.startPosition, this.props.endPosition]);
        return (react_1.default.createElement("div", { className: "Slider w-full border relative", style: { padding: "40px 10px", height: 80 } },
            react_1.default.createElement("div", { ref: this.sliderRef })));
    };
    return Slider;
}(react_1.default.Component));
exports.Slider = Slider;
